// this is an autogenerated file from DesignSystem/TasksViewForm/Content/Content/Actions/Action/Letter/Generate/DocumentTemplate/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_TasksViewForm_Content_Content_Actions_Action_Letter_Generate_DocumentTemplate($organization_id: uuid!) {
  documents_get_document_templates_for_org(args: { org_id: $organization_id }) {
    id: _id
    text: name
  }
}

`